/**
 * @voltxampere/ui — Arduino Nano board variant (Sprint 47.5-2)
 *
 * Compact Arduino Nano: ATmega328P + USB-mini + AMS1117 5V regulator
 * + 16MHz crystal. Smaller breadboard-friendly form factor than UNO
 * R3. Sprint 47.5 MVP same mcu-execution config as UNO R3 (atmega328p
 * 16MHz); board-level differences (USB connector, layout) are visual
 * only at this stage.
 *
 * Reference: Arduino Nano v3 (ATmega328P, USB-mini-B). 14 digital I/O
 * (6 PWM), 8 analog inputs (vs UNO 6), Vin 7-12V, 5V/3.3V dual rail.
 *
 * Engine zero-diff invariant honored — canonical `mcu-execution`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuArduinoNano = {
    id: "arduino-nano",
    nameTr: "Arduino Nano (ATmega328P, USB-mini)",
    nameEn: "Arduino Nano (ATmega328P, USB-mini)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "Arduino Nano",
    schemaType: "mcu-execution",
    defaultParams: {
        family: "atmega328p",
        clockHz: 16e6,
        flashHex: "",
        instructionsPerTick: 1000,
        vSupply: 5,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-arduino-nano.js.map